// extracted by mini-css-extract-plugin
module.exports = {"reported-segment":"reported-segment___3-zSm","line":"line___2lVWV","sub-header":"sub-header___1_YMZ","value":"value___1_Y45"};